import React, { useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import client from '../../../utils/api-client';
import { useAutoCompleteField } from '../../hooks/useAutocompleteField';
import useCombinedRefs from '../../hooks/useCombinedRefs';
import AutoComplete from './AutoComplete';

const getLabel = item => (item ? `${item.cityWithType ?? item.city}${item.city !== 'Москва' && item.city !== 'Санкт-Петербург' ? ` (${item.regionWithType})` : ''}` : '');

function CityAutoCompeteField({ name, disabled, inputRef, ...props }) {
  const { sessionId } = useSelector(state => state.app);
  const localInputRef = useRef();
  const getDataset = useCallback(search => client({ path: `/internal/suggest/area/${sessionId}`, method: 'GET' }, { q: search, bound: 'city' }).then(
    ({ suggestions }) => ({
      search,
      dataset: suggestions.map(
        (item, i) => ({
          id: i.toString(),
          label: getLabel(item),
          value: item,
        }),
      ),
    }),
  ), []);

  const field = useAutoCompleteField(name, getDataset, props);

  const initialValue = getLabel(props.initialValue ?? props.value);

  return (
    <AutoComplete
      {...props}
      {...field}
      inputRef={useCombinedRefs(localInputRef, inputRef)}
      disabled={disabled}
      className="address-autocomplete"
      initialValue={initialValue}
    />
  );
}

export default CityAutoCompeteField;
